import { Grid } from '@material-ui/core/'
import React from 'react'
import { mixpanel } from '../third_party/Mixpanel.jsx'
import ImageBox from './ImageBox.jsx'

const ituneUrl = 'https://itunes.apple.com/us/app/chowbus-next-stop-chow!/id1053160529?ls=1&mt=8'
const playStoreUrl = 'https://play.google.com/store/apps/details?id=com.chowbus.chowbus'

export const HomePageDownloadLinks = () => {
  const trackDownload = (platform) =>
    mixpanel.track({ name: 'Download App', properties: { platform } })

  return (
    <Grid container justify='center' spacing={2}>
      <Grid item xs={6} style={{ minWidth: 120 }}>
        <Grid container>
          <a href={ituneUrl} onClick={() => trackDownload('apple')}>
            <ImageBox fit='contain' src='/homepage/app-store-logo.png' alt='Apple App Store Logo' />
          </a>
        </Grid>
      </Grid>
      <Grid item xs={6} style={{ minWidth: 120 }}>
        <Grid container>
          <a href={playStoreUrl} onClick={() => trackDownload('android')}>
            <ImageBox
              src='/homepage/google-play-logo.png'
              alt='Google Play Store Logo'
              fit='contain'
            />
          </a>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default HomePageDownloadLinks
